import { render } from "./rich_text_editor.vue?vue&type=template&id=4600541f&scoped=true"
import script from "./rich_text_editor.vue?vue&type=script&lang=js"
export * from "./rich_text_editor.vue?vue&type=script&lang=js"

import "./rich_text_editor.vue?vue&type=style&index=0&id=4600541f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4600541f"]])

export default __exports__